import { Grid, Card, Text, Title, Table } from "@mantine/core";
import { BarChart } from "@mantine/charts";

export default function DashboardAdmin() {
  const stats = [
    { label: "Total Sekolah", value: 52 },
    { label: "Total Penyedia", value: 9 },
    { label: "Distribusi Bulan Ini", value: 233 },
  ];

  const chartData = [
    { month: "Jan", distribusi: 180 },
    { month: "Feb", distribusi: 220 },
    { month: "Mar", distribusi: 233 },
  ];

  const rows = [
    { sekolah: "SDN Mekarjaya 1", penyedia: "PT Maju Jaya", status: "Selesai" },
    { sekolah: "SDN Cinere 3", penyedia: "PT Sehat Selalu", status: "Proses" },
  ];

  return (
    <div>
      <Title order={3} mb="md">Dashboard Admin</Title>

      {/* Cards */}
      <Grid>
        {stats.map((s, i) => (
          <Grid.Col span={4} key={i}>
            <Card shadow="sm" p="lg">
              <Title order={2}>{s.value}</Title>
              <Text>{s.label}</Text>
            </Card>
          </Grid.Col>
        ))}
      </Grid>

      {/* Chart */}
      <Card mt="lg">
        <BarChart
          h={240}
          data={chartData}
          dataKey="month"
          series={[{ name: "distribusi", color: "blue" }]}
        />
      </Card>

      {/* Table */}
      <Card mt="lg">
        <Title order={4} mb="sm">Riwayat Distribusi Terbaru</Title>
        <Table striped withColumnBorders>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Sekolah</Table.Th>
              <Table.Th>Penyedia</Table.Th>
              <Table.Th>Status</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rows.map((r, i) => (
              <Table.Tr key={i}>
                <Table.Td>{r.sekolah}</Table.Td>
                <Table.Td>{r.penyedia}</Table.Td>
                <Table.Td>{r.status}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Card>
    </div>
  );
}
